(function($){
  $(document).ready(function() {

    formSiteRecherche = $('#site-recherche');

    $('.menu-recherche .menu_link').on('click', function(e){
        e.preventDefault();
        $(this).parents('.menu-recherche').toggleClass('open');
        formSiteRecherche.toggleClass('open');
        $('#search_terms').focus();
    });

    $('.site-recherche').submit(function(e){
        if ($('#search_terms').val() == ''){
            e.preventDefault();
            formSiteRecherche.removeClass('open');
        }
    });

  })
})(jQuery);
